import React from 'react';
import { motion } from 'framer-motion';
import { GitBranch, ExternalLink, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      icon: GitBranch,
      url: 'https://github.com/Sarwar009',
      color: 'hover:text-gray-300'
    },
    {
      name: 'LinkedIn',
      icon: ExternalLink,
      url: 'https://www.linkedin.com/in/sarwar009/',
      color: 'hover:text-blue-400'
    },
    {
      name: 'Email',
      icon: Mail,
      url: 'mailto:ssarwar459@gmail.com',
      color: 'hover:text-red-400'
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      url: 'https://wa.me/8801998787793',
      color: 'hover:text-green-400'
    }
  ];

  return (
    <footer className="relative bg-[#050505] text-gray-300 py-12 overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_left,rgba(139,92,246,0.18),transparent_25%),radial-gradient(circle_at_bottom_right,rgba(59,130,246,0.14),transparent_20%)]"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-8"
          >
            <h3 className="text-xl md:text-2xl font-black gradient-text group-hover:scale-105 transition-transform duration-300 origin-left mb-2">Golam Sarwar</h3>
            <p className="text-gray-400">Full Stack Developer</p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex justify-center gap-6 mb-8"
          >
            {socialLinks.map((social, index) => {
              const IconComponent = social.icon;
              return (
                <motion.a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`footer-link p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 group ${social.color}`}
                  whileHover={{ scale: 1.05, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <IconComponent className="w-5 h-5 text-gray-200 group-hover:text-white transition-all duration-300" />
                </motion.a>
              );
            })}
          </motion.div>

          {/* Divider */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-purple-500/30 to-transparent mb-8"></div>

          {/* Bottom Text */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-sm text-gray-500"
          >
            <p className="mb-2">
              © {currentYear} Golam Sarwar. All rights reserved.
            </p>
            <p className="flex items-center justify-center gap-2">
              Built with React & Tailwind CSS
            </p>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;